import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
import { StudentTeam } from 'Src/helpers/service/student/teams';

export interface ChildrenTeamsOverview {
  total: number;
  season: string;
  children: Array<{ id: string; firstName: string; lastName: string; avatar?: string; teams: StudentTeam[] }>;
}

export function getChildrenCurrentTeams(user: AppUser): Promise<ChildrenTeamsOverview> {
  return axios.get<ChildrenTeamsOverview>(`${window.apiBase}/i/children/teams/current/overview`, {
    headers: { usid: user.roleSessionKey }, params: { schoolId: user.activeSchoolId }
  }).then(response => response.data);
}
